import { ComponentProps, ReactNode, useEffect } from 'react'

import {
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverHeading,
  PopoverClose,
  PopoverTrigger,
  PopoverOverlay,
} from '@tovala/component-library'

type Placement = ComponentProps<typeof Popover>['placement']

const MenuTutorialPopover = ({
  children,
  description,
  heading,
  isOpen,
  onOpenChange,
  placement = 'top',
}: {
  children: ReactNode
  description: string
  heading: string
  isOpen: boolean
  onOpenChange(isOpen: boolean): void
  placement?: Placement
}) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Popover
      onOpenChange={onOpenChange}
      open={isOpen}
      placement={placement}
      popoverArrow={true}
      popoverStyle="dark"
    >
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      {isOpen && (
        <PopoverOverlay
          className="z-30 h-full w-full bg-black opacity-20"
          lockScroll
        >
          <PopoverContent className="z-40">
            <div className="absolute right-3">
              <PopoverClose />
            </div>
            <div className="space-y-2">
              <PopoverHeading>{heading}</PopoverHeading>
              <PopoverDescription>{description}</PopoverDescription>
            </div>
          </PopoverContent>
        </PopoverOverlay>
      )}
    </Popover>
  )
}

export default MenuTutorialPopover
